<template>
    <Select
        v-model="selection"
        :options="optionList"
        filter
        optionLabel="label"
        placeholder=" "
        class="w-full"
        @update:model-value="onValueChanged"
    >
        <template #value="slotProps">
            <div>
                <div v-if="slotProps.value" class="flex items-center">
                    <img
                        v-if="props.type == LocalizableType.country"
                        src="https://primefaces.org/cdn/primevue/images/flag/flag_placeholder.png"
                        :class="`mr-2 flag flag-${slotProps.value.value.toLowerCase()}`"
                        style="width: 18px"
                    />
                    <div>{{ slotProps.value.label }}</div>
                </div>
                <span class="invisible" v-else> Hello </span>
            </div>
        </template>
        <template #option="slotProps">
            <div class="flex items-center">
                <div>{{ slotProps.option.label }}</div>
            </div>
        </template>
    </Select>
</template>

<script setup>
import { ref, onMounted, defineEmits, defineProps, watch } from "vue";
import { LocalizableType } from "@/core/enums/LocalizableEnum";
import { Select } from "primevue";
import { countries } from "countries-list";
import { languages } from "countries-list";

const emit = defineEmits(["selectedValue"]);

const optionList = ref([]);
const selection = ref();

const props = defineProps({
    type: {
        default: LocalizableType.language,
    },
    selection: {
        type: String,
    },
});

const stop = watch(
    () => props.selection,
    () => {
        const item = optionList.value.find((option) => option.value === props.selection);

        selection.value = item;
        stop();
    },
);

onMounted(() => {
    let newList = [];

    Object.entries(props.type == LocalizableType.country ? countries : languages).forEach(([key, value]) => {
        newList.push({ value: key, label: value.name });
    });

    newList.sort((a, b) => a.label.localeCompare(b.label));

    optionList.value = newList;
});

const onValueChanged = (newValue) => {
    emit("selectedValue", newValue);
};
</script>

<style scoped>
@import "../../styles/flags.css";
</style>
